<template>

  <v-dialog
    v-model="show"
    persistent
    fullscreen
    >
    <v-card class="pa-1">
        <div style="height: 48px;" class="hidden-print-only">
        <v-icon style="float: right" class="hidden-print-only" @click="emitToParent('close')" >mdi-close-circle</v-icon>
        <v-icon style="float: right" class="hidden-print-only" @click="$printThis()" >mdi-printer</v-icon>
        </div>
            <div style="width: 49%; float: left;">
                <print-header />
            <p class="caption">
                <span style="float: right">Date: {{$moment().format("ll")}}</span>
                Customer: {{customer.firstname}}
            </p>
            <table class="cashier-table">
                <tr>
                    <td>Fish</td>
                    <td class="text-right">Price/Kg</td>
                    <td class="text-right">Kg</td>
                    <td class="text-right">Amount</td>
                    <td class="text-right">SC</td>
                    <td class="text-right">TF</td>
                    <td class="text-right">Total</td>
                </tr>
                 <tr v-for="(item,index) in items" :key="index" class="cashier-table-td">   
                    <td>
                    
                    {{ item.name }}
                    </td>
                    <td class="text-right">
                        {{ $money(item.price) }}
                    </td>
                    <td class="text-right">
                        {{ $money(item.kilos) }}   
                    </td> 
                    <td class="text-right">
                      {{ $money(parseFloat(item.kilos) * parseFloat(item.price)) }}
                    </td>
                    <td class="text-right">
                        {{ $money(item.service_charge) }}
                    </td>
                    <td class="text-right">
                        {{ $money(item.trucking_fee) }}
                    </td>
                    <td class="text-right">
                        {{ $money(($IsNum(item.price) * $IsNum(item.kilos)) +  $IsNum(item.trucking_fee) + $IsNum(item.service_charge)) }}
                    </td>
                </tr>
                <tr>
                    <td>
                    
                    </td>
                    <td>
                        
                    </td>
                    <td class="text-right">
                        {{ $money(KILOS) }}
                    </td>
                    <td class="text-right">
                        {{ $money(TOTAL_AMOUNT - SERVICE_CHARGE - TRUCKING_FEE) }}
                    </td>
                    <td class="text-right">
                        {{ $money(SERVICE_CHARGE) }}
                    </td>
                    <td class="text-right">
                        {{ $money(TRUCKING_FEE) }}
                    </td>
                    <td class="text-right">
                        {{ $money(TOTAL_AMOUNT) }}
                    </td>
                </tr>
            </table>
            </div>

             <div style="width: 49%; float: left;">
                  <print-header />
                   <p class="caption">
                <span style="float: right">Date: {{$moment().format("ll")}}</span>
                Customer: {{customer.firstname}}
            </p>
            <table class="cashier-table">
                <tr>
                    <td>Fish</td>
                    <td class="text-right">Price/Kg</td>
                    <td class="text-right">Kg</td>
                     <td class="text-right">Amount</td>
                    <td class="text-right">SC</td>
                    <td class="text-right">TF</td>
                    <td class="text-right">Total</td>
                </tr>
                 <tr v-for="(item,index) in items" :key="index" class="cashier-table-td">   
                    <td>
                    
                    {{ item.name }}
                    </td>
                    <td class="text-right">
                        {{ $money(item.price) }}
                    </td>
                    <td class="text-right">
                        {{ $money(item.kilos) }}
                    </td>
                    <td class="text-right">
                      {{ $money(parseFloat(item.kilos) * parseFloat(item.price)) }}
                    </td>
                    <td class="text-right">
                        {{ $money(item.service_charge) }}
                    </td>
                    <td class="text-right">
                        {{ $money(item.trucking_fee) }}
                    </td>
                    <td class="text-right">
                        {{ $money(($IsNum(item.price) * $IsNum(item.kilos)) +  $IsNum(item.trucking_fee) + $IsNum(item.service_charge)) }}
                    </td>
                </tr>
                <tr>
                    <td>
                    
                    </td>
                    <td>
                        
                    </td>
                    <td class="text-right">
                        {{ $money(KILOS) }}
                    </td>
                    <td class="text-right">
                        {{ $money(TOTAL_AMOUNT - SERVICE_CHARGE - TRUCKING_FEE) }}
                    </td>
                    <td class="text-right">
                        {{ $money(SERVICE_CHARGE) }}
                    </td>
                    <td class="text-right">
                        {{ $money(TRUCKING_FEE) }}
                    </td>
                    <td class="text-right">
                        {{ $money(TOTAL_AMOUNT) }}
                    </td>
                </tr>
            </table>
            </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    items: {
        type: Array,
        default:()=>{ return [] }
    },
    customer: {
        type: Object,
        default:()=>{ return {} }
    }
  },
  data: () => ({
    headers:[
            {text: 'Fish', value: 'name', sortable: false},
            {text: 'Price/Kg', value: 'price', sortable: false},
            {text: '(Kg)', value: 'kilos', sortable: false, align: 'right'},
             {text: 'SC', value: 'service_charge', sortable: false, align: 'right'},
            {text: 'TF', value: 'trucking_fee', sortable: false, align: 'right'},
            {text: 'Amount',sortable: false, align: 'right'}
        ]
  }),
  computed: {
      AMOUNT() {
          var total = 0
            for(var i =0;i<this.items.length;i++) {
              total += this.$IsNum(this.items[i].price) * this.$IsNum(this.items[i].kilos)
          }
          return total
      },
      KILOS() {
          var total = 0
            for(var i =0;i<this.items.length;i++) {
              total += this.$IsNum(this.items[i].kilos)
          }
          return total
      },
      SERVICE_CHARGE() {
          var total = 0
            for(var i =0;i<this.items.length;i++) {
              total += this.$IsNum(this.items[i].service_charge)
          }
          return total
      },
      TRUCKING_FEE() {
          var total = 0
            for(var i =0;i<this.items.length;i++) {
              total += this.$IsNum(this.items[i].trucking_fee)
          }
          return total
      },
      TOTAL_AMOUNT(){
          return this.AMOUNT + this.SERVICE_CHARGE + this.TRUCKING_FEE
      },
  },
  methods: {
       emitToParent (action) {
            this.$emit('DialogEvent', action)
    },
  }
}
</script>
<style>
    .cashier-table {
        font-size: .7em !important;
        width: 100%;
    }
    .cashier-table-td {
         font-size: .9em !important;
    }
    .cashier-table td {
        padding: 1px;
        border-bottom: 1px solid #222;
    }
</style>
